/** Path of the dashboard home, where a non-partner lands from the partner page. */
export const DASHBOARD_PATH = "/muggleTestV0/dashboard";
const ADMIN_PATH = `${DASHBOARD_PATH}/admin`;

/** Path of the partner's own dashboard page. */
export const PARTNER_PAGE_PATH = `${DASHBOARD_PATH}/partner`;

/** Path of the admin partner management page. */
export const ADMIN_PARTNERS_PATH = `${ADMIN_PATH}/partners`;

/** Path of the admin referral search page. */
export const ADMIN_REFERRALS_PATH = `${ADMIN_PATH}/referrals`;

/** Query parameter of the admin referrals page that opens it searching for one referral by id. */
export const ADMIN_REFERRAL_ID_QUERY_PARAM = "referralId";

/** Path of the admin partner statement review page. */
export const ADMIN_PARTNER_STATEMENTS_PATH = `${ADMIN_PATH}/partner-statements`;

/** Path of the admin source-of-sales report page. */
export const ADMIN_SOURCE_OF_SALES_PATH = `${ADMIN_PATH}/source-of-sales`;
